/*
@function calculateLotsizeScore
@param {Object} listing
@param {String} filterValue
*/
function calculateLotsizeScore(listing, filterValue) {
    var weight = 1;
    var value = 0;
    var threshold = 0;
    var lotsize = listing.lot_size;

    if(lotsize < 100) {
        lotsize = lotsize * 43560;
    }

    if(filterValue === 'small') {
        if(lotsize < 10000) {
            value = 10;
        } else if(lotsize <= 40000) {
            value = 0;
        } else {
            value = -10;
        }
    } else if(filterValue === 'medium') {
        if(10000 <= lotsize && lotsize <= 40000) {
            value = 10;
        } else {
            value = 0;
        }
    } else if(filterValue === 'large') {
        if(lotsize > 40000) {
            value = 10;
        } else if(lotsize >= 10000) {
            value = 0;
        } else {
            value = -10;
        }
    }

    var metWhyWhyNotThreshold;
    if(value == 10) {
        metWhyWhyNotThreshold = true;
    } else if (value == -10) {
        metWhyWhyNotThreshold = false;
    } else {
        metWhyWhyNotThreshold = 'neutral';
    }

    return {
        weight: weight,
        value: value,
        score: value * weight,
        metThreshold: (value * weight) >= threshold,
        metWhyWhyNotThreshold: metWhyWhyNotThreshold
    };
}

module.exports = calculateLotsizeScore;
